import React, { useCallback, useState } from 'react';
import * as S from './sales-support.style';
import {
  LogoIcon,
  MailIcon,
  PhoneIcon,
  CopyIcon,
  UIText,
} from '@/component-library';
import { IconCircle } from '../_Common/IconCircle';
import { ToolTip } from '../_Common/ToolTip';
import { Circle } from '../_Common/IconCircle/icon-circle.styles';

export const LotSalesSupport: React.FC<{
  title: string
  contactTitle: string
  phone: string
  email: string
  icon?: {
    title: string
    url: string
  }
}> = ({ title, /* contactTitle, */ email, phone, icon }) => {
  if (!email && !phone) return null

  return (
    <S.Container>
      <h2>{title}</h2>

      <S.HeaderGroup>
        {icon ? (
          <Circle>
            <img alt={icon.title} src={icon.url} />
          </Circle>
        ) : (
          <IconCircle Icon={LogoIcon} />
        )}
        <div>
          <UIText>
            <sup>E</sup>Ric <sub>(MacRobert)</sub> Lavers
          </UIText>
          <UIText label="position">Enterprise JavaScript Writer</UIText>
        </div>
      </S.HeaderGroup>
      <S.FieldSet>
        {phone && <RevealPhoneNumber phone={phone} trackClick={() => {}} />}
        {email && (
          <SalesContactButton
            Icon={MailIcon}
            content="Email"
            value={email}
            title="Copy email"
            onClick={() => {
              navigator.clipboard.writeText(email)

              window.open(`mailto:${email}`)
            }}
          />
        )}
      </S.FieldSet>
    </S.Container>
  )
}

const RevealPhoneNumber: React.FC<{
  phone: string;
  trackClick: () => void;
}> = ({ phone, trackClick }) => {
  const [reveal, s_reveal] = useState(false);

  const handleClick = useCallback(
    function () {
      if (reveal) {
        navigator.clipboard.writeText(phone);
        window.open(`tel:${phone}`, '_self');
      } else {
        s_reveal(true);
        trackClick();
      }
    },
    [reveal]
  );

  return (
    <SalesContactButton
      Icon={PhoneIcon}
      content={reveal ? phone : 'Call'}
      value={phone}
      title="Copy number"
      onClick={handleClick}
      onCopyClick={trackClick}
    />
  );
};

const SalesContactButton: React.FC<{
  Icon: any;
  content: any;
  value: any;
  title?: string | undefined;
  onClick: any;
  onCopyClick?: any;
}> = ({
  Icon,
  content,
  value,
  title = 'Copy',
  onClick,
  onCopyClick = () => {},
}) => (
  <div>
    <S.Button onClick={onClick}>
      <Icon width={20} />
      <span>{content}</span>
    </S.Button>
    <ToolTip
      closeOnTriggerHidden
      trigger="click"
      placement="bottom"
      content="Copied"
      offset={[0, 0]}
      customTrigger={
        <S.Button
          title={title}
          onClick={() => {
            onCopyClick?.(value);
            navigator.clipboard.writeText(value);
          }}
        >
          <CopyIcon fill="black" width={20} />
        </S.Button>
      }
    />
  </div>
);
